import _toConsumableArray from "C:/Users/mfink/Documents/CodeProjects/GTA Max Profit 2.0/gtamaxprofit-react-gatsby-client/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Chart, registerables } from '../dist/chart.esm';
Chart.register.apply(Chart, _toConsumableArray(registerables));
export default Chart;